import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Flame, ArrowRight, Tag } from "lucide-react";
import { api } from "@/lib/api";
import { usePageMeta } from "@/lib/seo";
import ProductCard from "@/components/shop/ProductCard";

export default function DealsPage() {
  usePageMeta(
    "Hot Deals — Save Big",
    "Today's hottest deals at IPVALUE MARKETPLACE — furniture, e-bikes, pallets and more marked down or with bulk-buy savings. Serving Grand Rapids and West Michigan from our Grand Rapids, MI showroom."
  );
  const [deals, setDeals] = useState(null);

  useEffect(() => {
    api.get("/products/deals?limit=100").then((r) => setDeals(r.data)).catch(() => setDeals([]));
  }, []);

  return (
    <div data-testid="deals-page">
      {/* HERO */}
      <section className="bg-[#0A1C40] border-b-4 border-[#DC2626]">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-24 py-16 lg:py-20">
          <div className="inline-flex items-center gap-2 bg-[#DC2626] text-white px-3 py-1 text-xs font-black tracking-[0.25em] uppercase">
            <Flame className="w-3.5 h-3.5" /> Hot Deals
          </div>
          <h1 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tighter mt-5 text-white leading-[0.95]">
            Real markdowns.<br />
            <span className="text-[#FFC220]">Real wholesale prices.</span>
          </h1>
          <p className="mt-6 text-white/70 max-w-lg leading-relaxed">
            Every item below is marked down or carries an automatic bulk-buy
            discount. Prices apply in-store and online — pickup free, delivery
            free within 10 miles on orders $299+.
          </p>
        </div>
      </section>

      {/* GRID */}
      <section className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-24 py-14 lg:py-20">
        {deals === null ? (
          <div className="p-20 text-center ipv-eyebrow">Loading deals…</div>
        ) : deals.length === 0 ? (
          <div className="text-center py-20" data-testid="deals-empty">
            <Tag className="w-10 h-10 mx-auto text-gray-300" />
            <div className="font-display font-black text-2xl mt-6">
              New deals dropping soon.
            </div>
            <p className="text-gray-600 mt-2">
              Check back — or browse the full floor for wholesale pricing on everything.
            </p>
            <Link to="/shop" className="btn-primary inline-flex items-center gap-2 mt-8" data-testid="deals-empty-shop-btn">
              Shop the Floor <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        ) : (
          <>
            <div className="ipv-eyebrow text-[#DC2626] mb-8" data-testid="deals-count">
              {deals.length} deal{deals.length > 1 ? "s" : ""} live right now
            </div>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
              {deals.map((p) => (
                <ProductCard key={p.id} product={p} />
              ))}
            </div>
          </>
        )}
      </section>
    </div>
  );
}
